<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div style="float: right">
          <md-button class="md-success" @click="$router.push({ path: 'inspector-create'})">Create Inspector</md-button>
      </div>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>person</md-icon>
          </div>
          <h4 class="title">Inspector List</h4>
        </md-card-header>
        <md-card-content v-if="tableData.length == 0">
          <h4 >No data found.</h4>
        </md-card-content>
        <md-card-content v-else>
          <md-table :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="md-container-custom paginated-table" table-header-color="green" md-fixed-header>
            
          <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
           </md-table-toolbar>

          <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name" md-sort-by="name">{{ item.name  }}</md-table-cell>
              <md-table-cell md-label="Email" md-sort-by="email">{{ item.email }}</md-table-cell>
              <md-table-cell md-label="Phone Number">{{ item.phoneNumber }}</md-table-cell>
              <md-table-cell md-label="Created On" md-sort-by="created_at">{{ HumanReadableDateFormat(item.created_at, true) }}</md-table-cell>
              <md-table-cell md-label="Actions">
                  <md-button class="md-just-icon md-primary md-simple" title="Edit Inspector" @click="$router.push({ path: 'inspector-create', query: { id: item._id }})"><md-icon>edit</md-icon></md-button>&nbsp;&nbsp;
                  <md-button class="md-just-icon md-danger md-simple" title="Delete Inspector" @click="deleteInspector(item._id)"><md-icon>close</md-icon></md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { Pagination } from "@/components";
import InspectorService from "../../services/InspectorService";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      isDisabled: false,
      tableData: [],
      category: "",

      //Paginations
      searchedData: [],
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },

      //Sorting
      currentSort: "created_at",
      currentSortOrder: "asc",
    };
  },
  methods: {
    
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder == "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    getInspectors() {
      let data = {
      }
      InspectorService.getInspectors(data)
        .then((response) => {
            this.tableData = response.data.data;
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    deleteInspector(id) {
      Swal.fire({
        title: "Are you sure?",
        text: `Inspector & it's data will be deleted.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, Delete It!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id : id
          };
          InspectorService.deleteInspector(data)
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.getInspectors();
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
        }
      });
    }
  },
  beforeMount() {
    this.getInspectors()
  },
};
</script>
